import React, { useState, useEffect } from "react";
import SmallScreenImageChart from "./SmallScreenImageChart";
import LargeScreenImageChart from "./LargeScreenImageChart";

const ImageChart = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 960);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isSmallScreen ? <SmallScreenImageChart /> : <LargeScreenImageChart />;
};

export default ImageChart;
